import { FilterTypeOption, FilterValue, Row } from "@evergis/ui";

import { FilterConditionType } from "../../components/LayerFilter/types";

export interface SetTableValue {
  initial: Row[];
  current: Row[];
}

export type SetTableData = (state: SetTableValue | Record<string, unknown>) => void;

export interface TableFilterValue {
  filterType: FilterTypeOption;
  value: FilterValue;
  dataType: string;
  isInactive?: boolean;
}

export interface TableFilterState {
  [key: string]: TableFilterValue;
}

export interface TableQueryParams {
  query: string;
  conditions: FilterConditionType[];
}

export enum TableMenuValues {
  Settings = "settings",
  Access = "access",
  Copy = "copy",
  Export = "export",
  Delete = "delete",
}
